import React, { useContext, useEffect, useState } from 'react';
import { TokenContext } from '~/context/TokenContext';
import * as ActionsAuth from '~/store/modules/auth/actions';
import { useDispatch } from 'react-redux';
import ReactGA from 'react-ga4';
import { LoaderMini } from '~/components/Loaders';
import { Background, Box } from '../styles';
import {Container, CardContainer, TextSubtitle, TextTitle, Logo } from './styles';
import Primeiro from './EsteiraToken/Primeiro';
import Segundo from './EsteiraToken/Segundo';
import Terceiro from './EsteiraToken/Terceiro';
import Quarto from './EsteiraToken/Quarto';





function AcessoToken() {
	const { callVerifyDoc, getCodeByType, callVerifyCode, loadingToken, setLoadingToken } = useContext(TokenContext);
	const dispatch = useDispatch();
	const [title, setTitle] = useState("Confirmação de Segurança");
	const [subTitle, setSubTitle] = useState("");
	const [documento, setDocumento] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [typeSelected, setTypeSelected] = useState("");
	const [data, setData] = useState({
		access: '',
		nome: ''
	});
	const [step, setStep] = useState(1);
	const [inputValues, setInputValues] = useState({ input1: '', input2: '', input3: '', input4: '', input5: '', input6: '' });
	const [timer, setTimer] = useState({
		active: true,
		description: '',
		minute: '00',
		seconds: '00'
	});


	async function handleSearchByDocument() {
		setLoadingToken(true)
		const response = await callVerifyDoc(documento.replace(/[^A-Z0-9]/g, ''))

		if(response?.data?.documento_valido) {
			setSubTitle("")
			setErrorMessage("")
			setStep(2)
		} else {
			setErrorMessage("Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.")
		}

	}

	async function handleSelectTypeVerification(value) {
		setLoadingToken(true)
		const response = await getCodeByType(documento.replace(/[^A-Z0-9]/g, ''), value)

		if(response?.data?.email || response?.data?.telefone) {
			if(value === 'sms'){
				setSubTitle(`Como forma de segurança, enviamos um código Token via sms para o  número <i style='color: red'> ${response?.data?.telefone || ''} </i> . Informe o código abaixo: `)
			} else if(value === 'email'){
				setSubTitle(`Como forma de segurança, enviamos um código Token para o e-mail <i style='color: red'> ${response?.data?.email || ''} </i> . Informe o código abaixo:`)
			} else {
				setSubTitle("")
			}


			setErrorMessage("")
			setStep(3)
			setTypeSelected(value)
			setTimer({
				active: true,
				description: '',
				minute: '03',
				seconds: '00'
			})
		} else {
			setErrorMessage("Ocorreu um erro. Tente novamente.")
		}
	}

	async function handleVerifyCode() {
		setLoadingToken(true)
		setErrorMessage("")
		const code = `${inputValues.input1}${inputValues.input2}${inputValues.input3}${inputValues.input4}${inputValues.input5}${inputValues.input6}`;
		const response = await callVerifyCode(documento.replace(/[^A-Z0-9]/g, ''), code)

		if(response.status === 200) {
			if (response.data.access) {
				const dataInfo =response.data
				if (dataInfo.access.startsWith('b')) {
					dataInfo.access = dataInfo.access.slice(2);
				}

				if (dataInfo.access.endsWith("'")) {
					dataInfo.access = dataInfo.access.slice(0, -1);
				  }

				setTitle("Acesso Permitido!")
				setSubTitle(`<p><b> Olá ${dataInfo?.nome || 'usuário'}!</b> </p> <p>Seu acesso foi efetuado com sucesso! Clique abaixo para continuar com acesso ao portal.</p>`)

				setData(dataInfo)
				setErrorMessage("")
				setStep(4)
			}
		} else if (!response?.data?.totp_valido){
			setErrorMessage("Token digitado está incorreto. Tente novamente.")
		}
	}

	function handleClickLoginByTokenGA4() {
		ReactGA.event({
			category: "login_by_token",
			action: `Login Token - ${typeSelected === 'sms' ? 'SMS' : 'E-mail'}`,
			label: `Login Token - ${typeSelected === 'sms' ? 'SMS' : 'E-mail'}`,
		});
	}

	function handleSubmitLogin() {
		if (data.access) {
			dispatch(ActionsAuth.requestLogin(data.access));
			handleClickLoginByTokenGA4();
		}
	}

	useEffect(() => {
		setLoadingToken(false)
		setErrorMessage('');
	}, [step])

	return (
		<Container>
			<Background />
			<div className="d-flex justify-content-center w-100">
				<Box style={{ borderRadius: " 0px 30px 0px 0px" }}>
					<CardContainer>
						{loadingToken
						?
							<LoaderMini width="70" />
						:
						 <>
							<Logo />
							<TextTitle dangerouslySetInnerHTML={{ __html: title }} />
							<TextSubtitle dangerouslySetInnerHTML={{ __html: subTitle }}  />
						 </>
						}


						{step === 1 &&
							<Primeiro
								loading={loadingToken}
								verifyDocument={() => handleSearchByDocument()}
								step={step}
								documento={documento}
								setDocumento={setDocumento}
								errorMessage={errorMessage}
								setErrorMessage={setErrorMessage}
							 />
						}

						{step === 2 &&
							<Segundo
								setSubTitle={setSubTitle}
								verifyType={(event) => handleSelectTypeVerification(event)}
								step={step}
								setStep={setStep}
								typeSelected={typeSelected}
								setTypeSelected={setTypeSelected}
							 />
						}

						{step === 3 &&
							<Terceiro
								loading={loadingToken}
								timer={timer}
								setTimer={setTimer}
								errorMessage={errorMessage}
								setErrorMessage={setErrorMessage}
								inputValues={inputValues}
								setInputValues={setInputValues}
								setSubTitle={setSubTitle}
								getNewCode={(event) => handleSelectTypeVerification(event)}
								verifyCode={() => handleVerifyCode()}
								step={step}
								setStep={setStep}
								typeSelected={typeSelected}
								setTypeSelected={setTypeSelected}
							/>
						}

						{step === 4 &&
							<Quarto
								setSubTitle={setSubTitle}
								setTitle={setTitle}
								step={step}
								setStep={setStep}
								submitLogin={() => handleSubmitLogin()}
								typeSelected={typeSelected}
								setTypeSelected={setTypeSelected}
							 />
						}
					</CardContainer>
				</Box>
			</div>
		</Container>
	);
}

export default AcessoToken;
